/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//English (United Kingdom)
export default {
  'fabric.editor.chromeCollapsedPlaceholder': 'Type something…',
  'fabric.editor.editorAssistiveLabel': 'Main content area, start typing to enter text.',
  'fabric.editor.headingLink.toolbarHelpTitle': 'Open help dialog',
};
